import React from "react";

const FilterPanel = ({
  categories = [],
  onFilterChange,
  onPriceChange,
  onSortChange,
  selectedSort = "",
  selectedPrice = 50000,
}) => {
  return (
    <div className="bg-gray-800 rounded-xl p-4 text-white space-y-6 shadow-md border border-gray-700">
      <h2 className="text-lg font-bold">Filters</h2>
  {/* Sort By Filter */}
      <div>
        <label className="block text-sm mb-1">Sort By</label>
        <select
          value={selectedSort}
          onChange={onSortChange}
          className="w-full bg-gray-700 text-white text-sm p-2 rounded-md capitalize"
        >
          <option value="">Default</option>
          <option value="low-to-high">Price: Low to High</option>
          <option value="high-to-low">Price: High to Low</option>
          <option value="name-asc">Name: A to Z</option>
          <option value="name-desc">Name: Z to A</option>
        </select>
      </div>


      {/* Price Range Filter */}
      <div>
        <label className="block text-sm mb-1">Max Price: ₹{selectedPrice}</label>
        <input
          type="range"
          min="0"
          max="100000"
          step="1000"
          value={selectedPrice}
          onChange={onPriceChange}
          className="w-full"
        />
      </div>

    
    </div>
  );
};

export default FilterPanel;
